import React from "react";
import { Formik } from "formik";
import "./Form.scss";
import Buttons from "../Button/Buttons";

const Form = ({
	children,
	validate,
	valuesForm: values,
	handleSubmit,
	type,
}) => {
	return (
		<div className="formFormik">
			<Formik
				initialValues={values}
				onSubmit={handleSubmit}
				validationSchema={validate}
			>
				{(formik) => (
					<form className="customForm" onSubmit={formik.handleSubmit}>
						{children}
						<Buttons type="submit" className="submitBtn btnPrimary">
							{type === "edit" ? "Editar" : "Agregar"}
						</Buttons>
					</form>
				)}
			</Formik>
		</div>
	);
};

export default Form;
